export function set(pouch) {
    return { type: 'POUCH/SET', pouch }
}
export function clear() {
    return { type: 'POUCH/SET', pouch: null }
}